import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReactosComponent } from './simple-icons-reactos.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReactosComponent ],
    exports:      [ SimpleIconsReactosComponent ],
    bootstrap:    []
})
export class SimpleIconsReactosModule {}
